export const Actions = {
  WithdrawPoint_ListRequest: 'WithdrawPoint_ListRequest',
  WithdrawPoint_ApproveRequest: 'WithdrawPoint_ApproveRequest',
  WithdrawPoint_ApproveBidvAutoRequest: 'WithdrawPoint_ApproveBidvAutoRequest',
  WithdrawPoint_RejectRequest: 'WithdrawPoint_RejectRequest',

  ManageCompany_ListCompany: 'ManageCompany_ListCompany',
  ManageCompany_CreateCompany: 'ManageCompany_CreateCompany',
  ManageCompany_UpdateCompany: 'ManageCompany_UpdateCompany',
  ManageCompany_RemoveCompany: 'ManageCompany_RemoveCompany',

  ManageHiloEInvoiceAccount_List: 'ManageHiloEInvoiceAccount_List',
  ManageHiloEInvoiceAccount_Create: 'ManageHiloEInvoiceAccount_Create',
  ManageHiloEInvoiceAccount_Update: 'ManageHiloEInvoiceAccount_Update',
  ManageHiloEInvoiceAccount_Delete: 'ManageHiloEInvoiceAccount_Delete',

  ManageUser_ListUser: 'ManageUser_ListUser',
  ManageUser_CreateUser: 'ManageUser_CreateUser',
  ManageUser_CreateMultipleUser: 'ManageUser_CreateMultipleUser',
  ManageUser_UpdateUser: 'ManageUser_UpdateUser',
  ManageUser_UpdateFinancialLimit: 'ManageUser_UpdateFinancialLimit',
  ManageUser_RemoveUser: 'ManageUser_RemoveUser',
  ManageUser_AddPointToUser: 'ManageUser_AddPointToUser',
  ManageUser_UpdateUserPassword: 'ManageUser_UpdateUserPassword',
  ManageUser_ActiveUser: 'ManageUser_ActiveUser',
  ManageUser_DeactiveUser: 'ManageUser_DeactiveUser',

  TPBank_InqueryTransaction: 'TPBank_InqueryTransaction',
  TPBank_ResendTransaction: 'TPBank_ResendTransaction',

  ManageReferralEvent_ViewEvent: 'ManageReferralEvent_ViewEvent',
  ManageReferralEvent_UpdateEvent: 'ManageReferralEvent_UpdateEvent',
  ManageReferralEvent_CreateEvent: 'ManageReferralEvent_CreateEvent',
  ManageReferralEvent_ListTransaction: 'ManageReferralEvent_ListTransaction',

  ManageOilMerchant_ListOilStoreType: 'ManageOilMerchant_ListOilStoreType',
  ManageOilMerchant_UpdateOilStoreType: 'ManageOilMerchant_UpdateOilStoreType',

  ManageOilMerchant_ListOilSupplier: 'ManageOilMerchant_ListOilSupplier',
  ManageOilMerchant_CreateOilSupplier: 'ManageOilMerchant_CreateOilSupplier',
  ManageOilMerchant_UpdateOilSupplier: 'ManageOilMerchant_UpdateOilSupplier',
  ManageOilMerchant_DeleteOilSupplier: 'ManageOilMerchant_DeleteOilSupplier',

  ManageOilMerchant_ListOilStore: 'ManageOilMerchant_ListOilStore',
  ManageOilMerchant_CreateOilStore: 'ManageOilMerchant_CreateOilStore',
  ManageOilMerchant_UpdateOilStore: 'ManageOilMerchant_UpdateOilStore',
  ManageOilMerchant_DeleteOilStore: 'ManageOilMerchant_DeleteOilStore',

  ManageOilMerchant_GetOilStoreTransaction:
    'ManageOilMerchant_GetOilStoreTransaction',

  // ManageBIDVVAS_ListVA: 'ManageBIDVVAS_ListVA',
  // ManageBIDVVAS_CreateVA: 'ManageBIDVVAS_CreateVA',
  // ManageBIDVVAS_CreateMultipleVA: 'ManageBIDVVAS_CreateMultipleVA',
  // ManageBIDVVAS_UpdateVA: 'ManageBIDVVAS_UpdateVA',
  // ManageBIDVVAS_RemoveVA: 'ManageBIDVVAS_RemoveVA',
  // ManageBIDVVAS_InqueryTransaction: 'ManageBIDVVAS_InqueryTransaction',
  // ManageBIDVVAS_SyncTransaction: 'ManageBIDVVAS_SyncTransaction',
  // ManageBIDVVAS_GenQRVA: 'ManageBIDVVAS_GenQRVA',
  // ManageDigitalSignature: 'ManageDigitalSignature',
  ManageBIDVTransaction_Inquiry: 'ManageBIDVTransaction_Inquiry',
  ManageBIDVTransaction_Sync: 'ManageBIDVTransaction_Sync',
  ManageBIDVTransaction_HealthCheck: 'ManageBIDVTransaction_HealthCheck',
  ManageHiloEInvoiceAccount_HealthCheck:
    'ManageHiloEInvoiceAccount_HealthCheck',
  ManageCKSCert_HealthCheck: 'ManageCKSCert_HealthCheck',

  ManageMerchantCredential_List: 'ManageMerchantCredential_List',
  ManageMerchantCredential_Create: 'ManageMerchantCredential_Create',
  ManageMerchantCredential_Update: 'ManageMerchantCredential_Update',
  ManageMerchantCredential_Revoke: 'ManageMerchantCredential_Revoke',

  ManageAppVersionConfig_Update: 'ManageAppVersionConfig_Update',
  ManageSmsRateLimit_Unlock: 'ManageSmsRateLimit_Unlock',
  ManageBalanceOperationControls_View: 'ManageBalanceOperationControls_View',
  ManageBalanceOperationControls_Update:
    'ManageBalanceOperationControls_Update',

  ManageBIDVBankTransfer_ViewWhitelist: 'ManageBIDVBankTransfer_ViewWhitelist',
  ManageBIDVBankTransfer_UpdateWhitelist:
    'ManageBIDVBankTransfer_UpdateWhitelist',
  ManageBIDVTransferDestWhitelist_List: 'ManageBIDVTransferDestWhitelist_List',
  ManageBIDVTransferDestWhitelist_Create:
    'ManageBIDVTransferDestWhitelist_Create',
  ManageBIDVTransferDestWhitelist_Update:
    'ManageBIDVTransferDestWhitelist_Update',
  ManageBIDVTransferDestWhitelist_Delete:
    'ManageBIDVTransferDestWhitelist_Delete',

  ManageTransferWithEvidence_List: 'ManageTransferWithEvidence_List',
  ManageTransferWithEvidence_ApproveBidv:
    'ManageTransferWithEvidence_ApproveBidv',
  ManageTransferWithEvidence_ApproveManual:
    'ManageTransferWithEvidence_ApproveManual',
  ManageTransferWithEvidence_Reject: 'ManageTransferWithEvidence_Reject',
} as const;

export type ActionKey = keyof typeof Actions;
